import PracticeMembersAPI from 'api/PracticeMembersAPI'
import UsersAPI from 'api/UsersAPI'
import Store from '@/store'

export function updateStoreMembers(input) {
    return PracticeMembersAPI.getList(Store.getters['auth/getPractice'].id)
        .then((members) => Store.dispatch('auth/setMembers', members))
        .then(() => input)
        .catch(() => Promise.resolve(input))
}

export function updateCurrentUser() {
    return UsersAPI.getCurrent().then((user) => Store.dispatch('auth/setUser', user))
}
